/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	type RouteResource,
	type RouterContext,
	createResource,
} from '@atlassian/react-resource-router';
import type { TranslationResponse } from './TranslationPanel.types.tsx';
import type { OutGoingEmailStateResponse } from './OutGoingEmailStateResponse.types.tsx';

export const languageTranslationsResourceKey = 'JSM Language Translations';
export const outgoingEmailStateResourceKey =
	"Language Support Customer Notification's Outgoing Email State";
export const languageTranslationsResource: RouteResource<TranslationResponse> =
	createResource<TranslationResponse>({
		type: 'Language Translations',
		getKey: ({
			match: {
				params: { projectKey, languageKey },
			},
		}: RouterContext) => `${languageTranslationsResourceKey}-${projectKey}-${languageKey}`,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-language-translations" */
				'./getData.tsx'
			),
		maxAge: Infinity,
	});
export const outgoingEmailStateModelResource: RouteResource<OutGoingEmailStateResponse> =
	createResource<OutGoingEmailStateResponse>({
		type: 'Outgoing Email State Model',
		getKey: () => `${outgoingEmailStateResourceKey}`,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-Outgoing-Email-State" */
				'./GetDataGetData.tsx'
			),
		maxAge: Infinity,
	});
